$(function() {
  if ($('body.infos.edit_identity').length < 1) return

  // birth-date
  App.util.controlBirthDateInput()
})
